import { ExitToAppOutlined as LogoutIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface LogoutButtonProps {
    onLogout: () => void;
}

export const LogoutButton = ({ onLogout }: LogoutButtonProps) => {
    const { t } = useTranslation();

    return (
        <button
            onClick={onLogout}
            className={
                'flex items-center w-full p-2 transition-colors  text-red-600 hover:bg-red-50 gap-4'
            }
        >
            <LogoutIcon className={'size-5'} />
            <span className={'font-medium ml-3'}>{t('side_bar.logout')}</span>
        </button>
    );
};
